import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LockInfoComponent } from './lock-info.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [LockInfoComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    MatButtonModule,
    TranslateModule
  ],
  exports: [LockInfoComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class LockInfoModule {}
